import { obtainMailBox } from "../bootstrap";
import { readyTopicNameBuilder } from "..";
export const registerApplicationElement = (elementName, integrationInterface) => {
  const mailBox = obtainMailBox();
  if (!mailBox) {
    console.warn(`[MD] Could not register ${elementName} application element as mailBox was not available. Check that globals.js isn't replacing MD.`);
    return;
  }
  const uid = Math.floor(Math.random() * 1000000);
  mailBox.buildConsumerClient(`${elementName}__${uid}`).subscribeToTopic(readyTopicNameBuilder(elementName), (_, __, popAll) => popAll().forEach(callback => callback.call(integrationInterface, integrationInterface)), true);
};